import React, { useEffect, useState } from "react";
import {
    useAdjustInventoryMutation,
    useGetAllInventoryQuery,
    useGetInventoryQuery,
    useHsnBasedInventoryQuery,
} from "../../../Services/inventory/Inventory";
import LoadingSpinner from "../../../components/LoadingSpinner";
import EmptyRows from "../../../components/reusableComponent/EmptyRows";

import { toast } from "react-toastify";
import useThemeColors from "../../vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";

const InventoryList = () => {
    // const [inventoryData, setInventoryData] = useState([]);
    const [tableLoader, setTableLoader] = useState(false);

    const [buttonClicked, setButtonClicked] = useState(false);

    const [getInventory, setGetInventory] = useState([]);
    const [storeINventoryData, setStoreInventoryData] = useState<any>({});
    const [getHsnCode, setGetHsnCode] = useState('')
    const [detailedHsnInventoryClicked, setDetailedHsnInventoryClicked] = useState(false)
    const [particularHsnData, setParticularHsnData] = useState([])
    const [loading, setLoading] = useState<any>(false)

    // Adjusted inventory

    const { data: inventory, refetch: inventoryRefetch, isLoading: inventoryLoading, status: inventoryStatus } = useGetInventoryQuery(
        {}
    );







    const {data: hsnInventory} = useHsnBasedInventoryQuery(getHsnCode, {skip: !getHsnCode})
    const [adjustINventoryTrigger, {status:inventoryAdjustStatus}] = useAdjustInventoryMutation();


    useEffect(() => {
        if (inventoryAdjustStatus === "pending") {
            setLoading(true)
        }
        else {
            setLoading(false)
        }

    }, [inventoryAdjustStatus])

    useEffect(() => {
        if (hsnInventory) {

            setParticularHsnData(hsnInventory?.bifurcated_items)
        }

    }, [hsnInventory])


    useEffect(() => {
        if (inventory) {
            setGetInventory(inventory?.aggregated_data);
        }
    }, [inventory]);


    const {
        data: masterInventoryData,
        status,
        isLoading,
        refetch,
    } = useGetAllInventoryQuery({});

    // useEffect(() => {
    //     if (masterInventoryData) {
    //         setInventoryData(masterInventoryData?.results);
    //     }
    // }, [masterInventoryData]);

    useEffect(() => {
        if (status === "pending") {
            setTableLoader(true);
        } else {
            setTableLoader(false);
        }
    }, [status]);

    const masterTableHeader = [
        {label: "Sr. no.", key: 'srno.'},
        { label: "HSN code", key: "hsn" },
        {label: "Part number", key: "part_numb"},
        {label: "Part name", key: "inv_name"},
        // { label: "Part number", key: "part_id" },
        // { label: "Vendor name", key: "vendor_name" },
        // { label: "invoice number", key: "invoice_number" },
        { label: "Quantity", key: "quantity" },
        // { label: "Price per unit", key: "price" },
        // { label: "GST", key: "gst" },
        // { label: "Total price", key: "total" },
    ];

    const particularHsnHeader = [
        {label: "Sr. no.", key: 'srno.'},
        // { label: "HSN code", key: "hsn" },
        // { label: "Part number", key: "part_id" },
        { label: "Part name", key: "inv_name" },
        { label: "Vendor name", key: "vendor_name" },
        { label: "invoice number", key: "invoice_number" },
        { label: "Quantity", key: "quantity" },
        { label: "Price per unit", key: "price" },
        { label: "GST", key: "gst" },
        { label: "Total price", key: "total" },
    ];

    const isEditModal = (inventory) => {
        setButtonClicked(true);
        setStoreInventoryData(inventory);
        setDetailedHsnInventoryClicked(false)

    };

    const [partNumber, setPartNumber] = useState(
        storeINventoryData?.part_number
    );
    const [stockInQuantity, setStockInQuantity] = useState(null);
    const [stockOutQuantity, setStockOutQuantity] = useState(null);
    const [remarks, setRemarks] = useState("");


    useEffect(() => {
        if (storeINventoryData) {
            setPartNumber(storeINventoryData?.part_number);
        }
    }, [storeINventoryData]);

   

    const cancelHandler = () => {
        setButtonClicked(false);
    };

    const adjustINventorySaveHandler = async () => {
        const obj = {
            part_number: partNumber,
            stock_in: stockInQuantity > 0 ? stockInQuantity : 0,
            stock_out: stockOutQuantity > 0 ? stockOutQuantity : 0,
            remarks: remarks,
        };
       try {

        const response = await adjustINventoryTrigger(obj);

  if (response?.data) {
    toast.success("Inventory adjusted successfully");
    setButtonClicked(false);
    inventoryRefetch();
    setStockOutQuantity("")
    setStockInQuantity("")
  } else if (response?.error && typeof response.error === 'object' && 'data' in response.error) {
    // Here we safely check if error has data and message properties
    const message = (response.error as { data?: { message?: string } }).data?.message;
    console.log(message, "messagge")
    if (message) {
      toast.error(message ? message : "Invalid data");
    } else {
      toast.error("An unknown error occurred");
    }
  }
} catch (error) {
  // Optional: handle unexpected errors
  toast.error("Unexpected error");
}
    };


    const detailedInventoryHandler = (hsnCode:any) => {
        setGetHsnCode(hsnCode.hsn)
        setDetailedHsnInventoryClicked(true)
        // setDetailedHsnInventoryClicked(false)
    }

           const {
                          selectedColor,
                          selectedBackgroundColor,
                          selectedBorderColor,
                          selectedButtonBackgoundColors,
                          selectedButtonColors,
                      } = useThemeColors();
    return (
            <div className="vehicle-info-cont" style={{gap: "0"}}>

            {/* <div id="kt_app_content_container" className="app-container mx-5"> */}
               <div
                className="vehicle-info-middle"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px`, overflow: "hidden" }}
            >
                <div>
            {buttonClicked ? (
                <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>

                  
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        flexDirection: "column",
                        padding:"20px 20px",
                        paddingBottom: "0px"
                    }}
                >
                    <div style={{ display: "flex", gap: "10px" , justifyContent: "space-between"}}>
                        <div
                            style={{
                                display: "flex",
                                gap: "5px",
                                flexDirection: "column",
                                width: "100%"
                            }}
                        >
                            <label>Part number</label>
                            <input
                                style={{borderRadius: "30px"}}

                                className="form-control"
                                value={partNumber}
                                disabled
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "5px",
                                flexDirection: "column",
                                width: "100%"

                            }}
                        >
                            <label>Stock in quantity</label>
                            <input
                                style={{borderRadius: "30px"}}

                                placeholder="Stock in..."
                                className="form-control"
                                value={stockInQuantity}
                                onChange={(e) =>
                                    setStockInQuantity(e.target.value)
                                }
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "5px",
                                flexDirection: "column",
                                width: "100%"

                            }}
                        >
                            <label>Stock out quantity</label>
                            <input
                                style={{borderRadius: "30px"}}

                                placeholder="Stock out..."
                                className="form-control"
                                value={stockOutQuantity}
                                onChange={(e) =>
                                    setStockOutQuantity(e.target.value)
                                }
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "5px",
                                flexDirection: "column",
                                width: "100%"

                            }}
                        >
                            <label>Remarks</label>
                            <input
                                placeholder="Remarks..."
                                className="form-control"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                style={{borderRadius: "30px"}}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "end",
                            gap: "10px",
                            padding: "20px"
                        }}
                    >
                        <button
                            className="btn btn-secondary"
                            onClick={cancelHandler}
                            style={{
                                     border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                            }}
                        >
                            Cancel
                        </button>
                        <button
                     style={{
                                background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                                  //  cursor: brandName.trim() ? "pointer" : "not-allowed",


                            }}
                            
                            onClick={adjustINventorySaveHandler}
                        >
                            {loading ? <>Saving...<Loader /></> : "Save"}
                            
                        </button>
                    </div>
                </div>
                </div>

            ) : (
                <>
           
                        <div className="vehicle-info-middle-heading" style={{padding: "20px"}}>
                        
                                Inventory List
                        </div>
                    {/* </div> */}
                    <div          className="vehicle-info-bottom"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px`, borderRadius: "0px" , border: "0"}}
                    
                    >
                        <div>
                            <div
                                className="card"
                                style={{ backgroundColor: "rgb(247, 211, 197)" , borderRadius: "0px", padding: "5px"}}
                            >
                                <div className="row align-items-center" style={{padding: "10px",}}>
                                    {masterTableHeader?.map((card, index) => (
                                        <div className="col" key={index}  style={{cursor: "pointer"}}
                                        
                                        >
                                            <label htmlFor="">
                                                <strong
                                                    style={{
                                                        display: "flex",
                                                        gap: "2px",
                                                    }}
                                                >
                                                    {card?.label}
                                                </strong>
                                            </label>
                                        </div>
                                    ))}
                                    <div className="col">
                                        <label
                                            htmlFor=""
                                            style={{ paddingRight: "25px" }}
                                        >
                                            <strong>Action</strong>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Body */}

                    <div style={{maxHeight: "60vh" }}>
                        {isLoading || tableLoader ? (
                            <LoadingSpinner />
                        ) : (
                            <>
                                {!getInventory?.length ? (
                                    <EmptyRows value={""} />
                                ) : (
                                    <div
                                        className="col"
                                        style={{ paddingRight: "0px"}}
                                    >
                                        <>
                                            {getInventory?.length ? (
                                                <>
                                                      {getInventory?.map(
                                                    (inventory: any, index: any) => (
                                                        <div
                                                        style={{overflow: "hidden", padding: "10px", 
                                                             background: index % 2 !== 0 ? "#FFF1EC" : "white"
                                                            }}
                                                            // className="card mt-2 my-1 p-4"
                                                            key={index}
                                                            onClick={() => detailedInventoryHandler(inventory)}
                                                        >
                                                            <div className="row align-items-start">
                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                        }}
                                                                    >
                                                                        {index + 1}
                                                                    </label>
                                                                </div>
            
                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.hsn
                                                                        }
                                                                    </label>
                                                                </div>

                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.part_number
                                                                        }
                                                                    </label>
                                                                </div>

                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.inv_name
                                                                        }
                                                                    </label>
                                                                </div>


                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.quantity
                                                                        }
                                                                    </label>
                                                                </div>
            
            
                                                                <div
                                                                    className="col d-flex"
                                                                    style={{
                                                                        gap: "10px",
                                                     
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="text-hover-primary border-0 bg-white me-2"
                                                                        title="Edit"
                                                                        style={{ background: index % 2 === 0 ? "#FFF1EC" : "#FFF1EC"}}
                                                               
                                                                        onClick={() => isEditModal(inventory)}
                                                                    >
                                                                        <i className="bi bi-pencil" style={{
                                                                              background: index % 2 === 0 ? "white" : "#FFF1EC",
                                                                                fontSize: "20px",
                                                                                paddingRight: "20px",
                                                cursor: "pointer",
                                                                        }}></i>
                                                                    </button>
                                                             
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                                </>
                                            ) : (
                                                ""
                                                // <EmptyRows value={""} />
                                            )}
                                        </>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </>
            )}

            </div>
            </div>

{detailedHsnInventoryClicked &&
<div style={{display: "flex", justifyContent: "center", marginTop: "20px"}}><p style={{margin: "0", fontSize: "16px", fontWeight: "600"}}>Inventory entry</p></div>
}
            <div id="kt_app_content_container" className="app-container mx-5" >
            <div className="card card-flush">

            {detailedHsnInventoryClicked && 
<div >
<div className="row">
                        <div className="col">
                            <div
                                className="card"
                                style={{ backgroundColor: "#F7D3C5" }}
                            >
                                <div className="row align-items-center" style={{padding: "10px"}}>
                                    {particularHsnHeader?.map((card, index) => (
                                        <div className="col" key={index}>
                                            <label htmlFor="">
                                                <strong
                                                    style={{
                                                        display: "flex",
                                                        gap: "2px",
                                                        alignItems:"center"
                                                    }}
                                                >
                                                    {card?.label === "GST"  ? <>{card.label} %</> : card?.label === "Price per unit" ? (
  <span style={{display: "flex", alignItems: "center"}}>
    <i className="bi bi-currency-rupee" style={{color: "black"}}></i> {card.label}
  </span>): card.label}
                                                </strong>
                                            </label>
                                        </div>
                                    ))}
                              
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row" style={{overflow: "scroll" }}>
                        {isLoading || tableLoader ? (
                            <LoadingSpinner />
                        ) : (
                            <>
                                {!particularHsnData?.length ? (
                                    <EmptyRows value={""} />
                                ) : (
                                    <div
                                        className="col"
                                        style={{ paddingRight: "0px" }}
                                    >
                                        <>
                                            {particularHsnData?.length ? (
                                                <>
                                                      {particularHsnData?.map(
                                                    (inventory: any, index: any) => (
                                                        <div
                                                            className="card mt-2 my-1 p-4"
                                                            key={index}
                                                         
                                                        >
                                                            <div className="row align-items-start">
                                                                <div className="col text-start">
                                                                    <label
                                                                        htmlFor=""
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                        }}
                                                                    >
                                                                        {index + 1}
                                                                    </label>
                                                                </div>


                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.inv_name
                                                                        }
                                                                    </label>
                                                                </div>
            
                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.vendor_name
                                                                        }
                                                                    </label>
                                                                </div>


                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "10px"}}>
                                                                        {
                                                                            inventory?.invoice_number
                                                                        }
                                                                    </label>
                                                                </div>
            
                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "15px"}}>
                                                                        {inventory?.quantity}
                                                                    </label>
                                                                </div>
            
                                                                <div className="col text-start">
                                                                    <label htmlFor="" style={{paddingLeft: "18px"}}>
                                                                        {inventory?.price}
                                                                    </label>
                                                                </div>
            
                                                                <div
                                                                    className="col text-start"
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                            
                                                                >
                                                                    {inventory?.gst}
                                                                </div>

                                                                <div
                                                                    className="col text-start"
                                                                    data-toggle="tooltip"
                                                                    data-placement="top"
                                                              
                                                                >
                                                                    {inventory?.total}

{/* If qantity is 0 then  */}

                                                                    {/* Make it inventory.quantity * inventory.price + inventory.gst */}
                                                                </div>
            
                                                              
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                                </>
                                            ) : (
                                                ""
                                                // <EmptyRows value={""} />
                                            )}
                                        </>
                                    </div>
                                )}
                            </>
                        )}
                    </div>






</div>
}
</div>
</div>
        </div>
    );
};

export default InventoryList;
